import { categoryLang } from "../components/Category/categoryLang";
import { drawerFormLang } from "../components/DrawerForm/drawerFormLang";
import { feedbackLang } from "../components/Feedback/feedbackLang";
import { listingMenuLang } from "../components/ListingMenu/listingMenuLang";
import { pricingLang } from "../components/Pricing/pricingLang";
import { restaurantProfileLang } from "../components/ResturantProfile/restaurantProfileLang";
import { orderLang } from "../pages/Order/orderLang";
import { commonEng } from "./modules/common";

const eng = {
  default: {
    common: {...commonEng}
  },
  restaurantProfile: {...restaurantProfileLang.eng},
  feedback: {...feedbackLang.eng},
  category: {...categoryLang.eng},
  listingMenu: {...listingMenuLang.eng},
  order: {...orderLang.eng},
  pricing: {...pricingLang.eng},
  drawerForm: {...drawerFormLang.eng}
};

export default eng;
